import * as React from 'react';
import classNames from 'classnames';
import { ControlIcons } from 'owa-addins-icons';
import { Icon, IconType } from 'office-ui-fabric-react/lib/Icon';
import { IImageProps, Image, ImageFit, ImageLoadState } from 'office-ui-fabric-react/lib/Image';
import { observer } from 'mobx-react';

const styles = require('./TaskPaneHeader.scss');

export interface ImageWithFallbackState {
    hasLoadFailed: boolean;
}

@observer
export default class ImageWithFallback extends React.Component<
    IImageProps,
    ImageWithFallbackState
> {
    constructor(props: IImageProps) {
        super(props);
        this.state = { hasLoadFailed: false };
    }

    onLoadingStateChanged(loadState: ImageLoadState) {
        if (loadState == ImageLoadState.error) {
            this.setState({ hasLoadFailed: true });
        } else {
            this.setState({ hasLoadFailed: false });
        }
    }

    render() {
        const { hasLoadFailed } = this.state;

        if (hasLoadFailed) {
            return (
                <Icon
                    iconName={ControlIcons.Photo2}
                    iconType={IconType.default}
                    className={classNames([styles.fallbackIcon, this.props.className])}
                />
            );
        }

        return (
            <Image
                onLoadingStateChange={this.onLoadingStateChanged.bind(this)}
                src={this.props.src}
                width={this.props.width}
                height={this.props.height}
                imageFit={ImageFit.contain}
                className={this.props.className}
            />
        );
    }
}
